/**
 * FamilyPlanBanner Component
 *
 * Displays family plan status banner for family members
 * Shows manage button for admins
 */
import { View, Text, Pressable } from "react-native";
import { useTranslation } from "@dramadetector/shared";
import { TierBody } from "@dramadetector/ui";

interface FamilyPlan {
  id: string;
  tier: 'drama_plus' | 'dramax';
  status: string;
}

interface FamilyPlanBannerProps {
  familyPlan: FamilyPlan | null;
  isFamilyMember: boolean;
  isFamilyAdmin: boolean;
  onManageFamily: () => void;
}

export function FamilyPlanBanner({
  familyPlan,
  isFamilyMember,
  isFamilyAdmin,
  onManageFamily,
}: FamilyPlanBannerProps) {
  const { t } = useTranslation('subscription');

  if (!isFamilyMember || !familyPlan) {
    return null;
  }

  return (
    <View testID="family-status-banner" className="mx-4 mb-6 bg-purple-50 border border-purple-200 rounded-xl p-4">
      <TierBody weight="semibold" className="text-purple-900 mb-2">
        {t('family_banner.title', {
          tier: familyPlan.tier === 'drama_plus' ? t('tiers.drama_plus') : t('tiers.dramax')
        })}
      </TierBody>
      {isFamilyAdmin && (
        <Pressable
          onPress={onManageFamily}
          className="bg-purple-600 py-2 px-4 rounded-lg mt-2"
        >
          <Text className="text-white text-center font-semibold">
            {t('family.manageFamily')}
          </Text>
        </Pressable>
      )}
    </View>
  );
}
